import KeyInformation from '@/pages/CompanyReport/components/Introduction/components/KeyInformation';
import { useMemo } from 'react';
import { useBankMetrics } from '@/pages/CompanyReport/components/Health/Hooks';
import { addBadge } from './utils';

type Props = { canonicalURL: string };

export const KeyInformationBank = ({ canonicalURL }: Props) => {
  const { keyMetrics, metrics } = useBankMetrics(canonicalURL);
  const metricsWithBadge = useMemo(() => addBadge(metrics), [metrics]);
  return (
    <KeyInformation
      direction="row"
      keyMetrics={keyMetrics}
      metrics={metricsWithBadge}
    />
  );
};
